import { Box, Button, LoadingOverlay, Paper, SimpleGrid, Space, Text, Textarea, TextInput, Title } from '@mantine/core';
import React, { memo, useEffect, useState } from 'react';
import useFetch from '../../../../Customhooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
import { baseUrl } from '../../../../Constants/constant';
import { notifications } from '@mantine/notifications';
import classes from '../ManageDisposal.module.css';

const AddDisposal = () => {
    const navigate = useNavigate();
    const [disposaltype, setDisposalType] = useState<string>('');
    const [cotwo, setCoTwo] = useState<string>('');
    const [sourceName, setSourceName] = useState<string>('');
    const [sourceDescripton, setSourceDescripton] = useState<string>('');
    const [errors, setErrors] = useState<Record<string, string>>({});
    const token = localStorage.getItem("token")
    const { id } = useParams();
    const method = id ? 'PUT' : 'POST';
    const url = id ? `${baseUrl}admin/end-life/edit/${id}` : `${baseUrl}admin/end-life/add`;
    const {
        data: getData,
        loading: detailLoading,
        error: getError,
        fetchData: postmaterial,
    } = useFetch({
        method: method,
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
        body: JSON.stringify({
            name: disposaltype,
            co2_embodied: cotwo,
            source_name: sourceName,
            source_descripton: sourceDescripton
        }),
    });
    const {
        data: getfieldData,
        loading: getfieldLoading,
        error: getfielderror,
        fetchData: getfield,
    } = useFetch({
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
    });
    useEffect(() => {
        if (id) {
            getfield(`${baseUrl}admin/end-life/${id}`)
        }
    }, []);
    useEffect(() => {
        if (getfieldData?.data?.rows?.length) {
            setDisposalType(getfieldData?.data?.rows[0]?.name);
            setCoTwo(getfieldData?.data?.rows[0]?.co2_embodied);
            setSourceName(getfieldData?.data?.rows[0]?.source_name);
            setSourceDescripton(getfieldData?.data?.rows[0]?.source_descripton);
        }
    }, [getfieldData]);

    const handleChange = (field: string, value: string | null) => {
        if (field === "disposal_type") {
            setDisposalType(value as string);
        }
        else if (field === "co2_id") {
            setCoTwo(value as string);
        }
        else if (field === "source_name") {
            setSourceName(value as string);
        }
        else if (field === "source_descripton") {
            setSourceDescripton(value as string);
        }
        setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    };

    const validateFields = () => {
        let newErrors: Record<string, string> = {};

        if (!disposaltype.trim()) {
            newErrors.disposal_type = "Disposal is Required";
        }
        if (!cotwo) {
            newErrors.co2_id = "CO₂ is Required";
        }
        if (!sourceName) {
            newErrors.source_name = "Source Name is Required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false;
        }
        return true;
    };

    const handlesave = async () => {
        if (!validateFields()) return
        await postmaterial(url);
    };

    // UseEffect to show notification when getData or getError changes
    useEffect(() => {
        const showNotification = (type: any, title = "An error occurred") => {
            notifications.show({
                title,
                message: type === 'success'
                    ? "Disposal data saved successfully."
                    : "Something went wrong. Please try again.",
                color: type === 'success' ? "green" : "red",
                classNames: classes,
            });
        };

        if (getData?.errors || getError) {
            showNotification('error', getData?.message || getError?.message);
            return;
        }

        if (getData && !getData?.errors) {
            navigate('/disposal');
        }
    }, [getData, getError, navigate, classes]);



    return (
        <>
            <LoadingOverlay
                visible={getfieldLoading}
                zIndex={1000}
                overlayProps={{
                    radius: 'sm',
                    blur: 2,
                    style: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                }}
                loaderProps={{ color: '#404040', type: 'bars' }}
            />
            <Paper shadow="xs" p="xs" radius="md">
                <Box ml={5}>
                    <Title order={4}>Add Disposal</Title>
                    <Space h="lg" />
                    <Text>Disposal Details</Text>
                    <Space h="xs" />
                    <SimpleGrid cols={4}>
                        <TextInput
                            variant='filled'
                            label="Disposal"
                            withAsterisk
                            value={disposaltype}
                            onChange={(e) => handleChange("disposal_type", e.target.value)}
                            placeholder="Enter Disposal"
                            radius={6}
                            error={errors.disposal_type}
                        />

                        <TextInput
                            variant='filled'
                            withAsterisk
                            label="CO₂ Embodiment per g"
                            value={cotwo}
                            onChange={(e) => handleChange("co2_id", e.target.value)}
                            placeholder="Enter Embodied"
                            radius={6}
                            error={errors.co2_id}
                        />
                        <TextInput
                            variant='filled'
                            withAsterisk
                            label="Source"
                            value={sourceName}
                            onChange={(e) => handleChange("source_name", e.target.value)}
                            placeholder="Enter Source Name"
                            radius={6}
                            error={errors.source_name}
                        />
                        <Textarea
                            label="Source Description"
                            placeholder="Enter your Source Description"
                            variant="filled"
                            autosize
                            value={sourceDescripton}
                            onChange={(e) => handleChange("source_descripton", e.target.value)}
                            minRows={1}
                            maxRows={4}
                            radius={6}
                        />

                    </SimpleGrid>
                    <Space h="xl" />
                    <SimpleGrid cols={6}>
                        <Button
                            variant="default"
                            radius={6}
                            onClick={() => navigate('/disposal')}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="gradient"
                            gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                            radius={6}
                            onClick={handlesave}
                        >
                            {id ? 'Update' : 'Save'}
                        </Button>
                    </SimpleGrid>
                </Box>
            </Paper>
        </>
    )
}

export default memo(AddDisposal)